import colors from './colors';

export default {
  hover: `0 0 0 2px ${colors.hoverHalo}`,
  focus: `0 0 0 2px ${colors.focusHalo}`,
  active: `0 0 0 4px ${colors.activeHalo}`,
} as const;
